function initCustomizer() {
  const wrapper = document.querySelector(".customizer-section-wrapper");
  if (!wrapper) return;

  // ── 1. Configurations & Constants ───────────────────────────────────────────
  const basePrice = parseFloat(wrapper.dataset.basePrice) / 100 || 0;
  const productTitle = wrapper.dataset.productTitle;
  const fabricVariantId = wrapper.dataset.fabricVariantId;
  const tailoringVariantId = wrapper.dataset.tailoringVariantId;
  const tailoringPrice = parseFloat(wrapper.dataset.tailoringPrice) / 100 || 0;

  // ── 2. State Management ──────────────────────────────────────────────────────
  let state = {
    activeStep: 1,
    for: "Men",
    sizeMode: "standard", // standard | custom
    size: "",
    measurements: { neck: "", chest: "", waist: "", shoulder: "", sleeve: "", length: "" },
    collar: "Classic Spread",
    pocket: "No Pocket",
    sleeve: "Full Sleeve",
    placket: "Skinny Placket",
    bottom: "Tail Cut",
    back: "Box Pleats",
    buttons: "Classic Black",
    brandButton: "Yes",
    brandShow: true,
    monogramText: "",
    monogramPosition: "Left Chest",
    monogramColor: "navy"
  };

  const MEN_SIZES = ["M", "L", "XL", "XXL"];
  const BOYS_SIZES = ["5-6 Yrs", "7-8 Yrs", "9-10 Yrs", "11-12 Yrs", "13-14 Yrs"];

  // ── 3. DOM Cache ────────────────────────────────────────────────────────────
  const stepPills = document.querySelectorAll(".customizer-step-pill");
  const stepContents = document.querySelectorAll(".customizer-step-content");
  
  const prevBtn = document.querySelector(".customizer-fixed-bottom-bar .prev-btn");
  const nextBtn = document.querySelector(".customizer-fixed-bottom-bar .next-btn");
  const totalPriceDisplay = document.getElementById("customizer-total-price");
  const cartGroup = document.querySelector(".customizer-cart-group");
  const summaryTextDisplay = document.getElementById("bottom-summary-text");
  
  const standardSizesContainer = document.getElementById("standard-sizes-container");
  const sizeTabBtns = document.querySelectorAll(".size-tab-btn");
  const sizePanels = document.querySelectorAll(".size-mode-panel");
  
  const confirmCheckbox = document.getElementById("confirm-order-checkbox");
  const buyMaterialBtn = document.querySelector(".buy-material-btn");
  const addTailoredBtn = document.querySelector(".add-tailored-btn");

  // Modals
  const saveDesignBtn = document.getElementById("save-design-btn");
  const myDesignsBtn = document.getElementById("my-designs-btn");
  const saveModal = document.getElementById("save-design-modal");
  const listModal = document.getElementById("my-designs-modal");
  const saveNameInput = document.getElementById("save-design-name");
  
  // ── 4. Sizing Picker Setup ──────────────────────────────────────────────────
  function populateStandardSizes() {
    if (!standardSizesContainer) return;
    standardSizesContainer.innerHTML = "";
    const sizes = state.for === "Men" ? MEN_SIZES : BOYS_SIZES;
    
    sizes.forEach(s => {
      const btn = document.createElement("button");
      btn.type = "button";
      btn.className = "size-pill-btn";
      if (state.size === s) btn.classList.add("selected");
      btn.textContent = s;
      
      btn.addEventListener("click", () => {
        document.querySelectorAll(".size-pill-btn").forEach(el => el.classList.remove("selected"));
        btn.classList.add("selected");
        state.size = s;
        updateUI();
      });
      standardSizesContainer.appendChild(btn);
    });
  }

  sizeTabBtns.forEach(btn => {
    btn.addEventListener("click", () => {
      sizeTabBtns.forEach(b => b.classList.remove("active"));
      btn.classList.add("active");
      
      const mode = btn.dataset.sizeMode;
      state.sizeMode = mode;
      state.size = mode === "custom" ? "custom" : "";
      
      sizePanels.forEach(p => {
        p.style.display = p.dataset.panel === mode ? "block" : "none";
      });
      
      updateUI();
    });
  });

  const measurementInputs = document.querySelectorAll(".measure-input-field input");
  measurementInputs.forEach(input => {
    input.addEventListener("input", (e) => {
      const measureKey = e.target.dataset.measure;
      state.measurements[measureKey] = e.target.value;
      updateUI();
    });
  });

  // ── 5. Standard Stepper Interactions ────────────────────────────────────────
  const optionCards = document.querySelectorAll(".customizer-option-card");
  optionCards.forEach(card => {
    card.addEventListener("click", () => {
      const key = card.dataset.key;
      const val = card.dataset.value;

      const grid = card.closest(".customizer-options-grid");
      grid.querySelectorAll(".customizer-option-card").forEach(el => el.classList.remove("selected"));
      card.classList.add("selected");

      if (key === "for") {
        if (state.for !== val) {
          state.for = val;
          state.size = "";
          measurementInputs.forEach(i => i.value = "");
          state.measurements = { neck: "", chest: "", waist: "", shoulder: "", sleeve: "", length: "" };
          populateStandardSizes();
        }
      } else {
        state[key] = val;
      }

      updateUI();
    });
  });

  // Brand button "show on preview" toggle — DISPLAY ONLY. The brand button is
  // always included in the order (state.brandButton stays "Yes"); customers can
  // only remove it later from the cart. This toggle just shows/hides the brand
  // mark on the live preview.
  const brandToggleCard = document.getElementById("brand-toggle-card");
  if (brandToggleCard) {
    brandToggleCard.addEventListener("click", () => {
      state.brandShow = !state.brandShow;
      brandToggleCard.classList.toggle("selected", state.brandShow);
      updateUI();
    });
  }

  const monogramTextInput = document.getElementById("monogram-text");
  if (monogramTextInput) {
    monogramTextInput.addEventListener("input", (e) => {
      state.monogramText = e.target.value;
      updateUI();
    });
  }

  const monogramPosSelect = document.getElementById("monogram-position");
  if (monogramPosSelect) {
    monogramPosSelect.addEventListener("change", (e) => {
      state.monogramPosition = e.target.value;
      updateUI();
    });
  }

  const colorDots = document.querySelectorAll(".monogram-color-dot");
  colorDots.forEach(dot => {
    dot.addEventListener("click", () => {
      colorDots.forEach(d => d.classList.remove("selected"));
      dot.classList.add("selected");
      state.monogramColor = dot.dataset.colorId;
      updateUI();
    });
  });

  if (confirmCheckbox) {
    confirmCheckbox.addEventListener("change", updateUI);
  }

  prevBtn.addEventListener("click", () => {
    if (state.activeStep > 1) {
      state.activeStep--;
      goToStep(state.activeStep);
    }
  });

  nextBtn.addEventListener("click", () => {
    if (validateStep(state.activeStep)) {
      if (state.activeStep < 10) {
        state.activeStep++;
        goToStep(state.activeStep);
      }
    }
  });

  stepPills.forEach(pill => {
    pill.addEventListener("click", () => {
      const target = parseInt(pill.dataset.targetStep);
      let valid = true;
      for (let i = 1; i < target; i++) {
        if (!validateStep(i)) {
          valid = false;
          goToStep(i);
          break;
        }
      }
      if (valid) {
        state.activeStep = target;
        goToStep(target);
      }
    });
  });

  function goToStep(step) {
    const totalSteps = stepContents.length;
    stepContents.forEach(content => {
      content.style.display = parseInt(content.dataset.stepId) === step ? "block" : "none";
    });

    stepPills.forEach(pill => {
      const pNum = parseInt(pill.dataset.targetStep);
      pill.classList.remove("active", "completed");
      if (pNum === step) {
        pill.classList.add("active");
        pill.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
      } else if (pNum < step) {
        pill.classList.add("completed");
      }
    });

    // Update step counter and progress bar
    const stepNumEl = document.getElementById("active-step-num");
    if (stepNumEl) stepNumEl.textContent = `STEP ${step} OF ${totalSteps}`;
    const progressFill = document.getElementById("customizer-progress-fill");
    if (progressFill) progressFill.style.width = `${(step / totalSteps) * 100}%`;

    prevBtn.disabled = step === 1;
    if (step === 10) {
      nextBtn.style.display = "none";
      cartGroup.style.display = "flex";
    } else {
      nextBtn.style.display = "block";
      cartGroup.style.display = "none";
    }
    
    updateUI();
  }

  function validateStep(step) {
    if (step === 2) { 
      if (!state.size) {
        alert("Please select a standard size or fill custom measurements.");
        return false;
      }
      if (state.sizeMode === "custom") {
        const m = state.measurements;
        if (!m.neck || !m.chest || !m.waist || !m.shoulder || !m.sleeve || !m.length) {
          alert("Please fill in all custom measurements before continuing.");
          return false;
        }
        if (parseFloat(m.length) > 37) {
          alert("Max length is 37 inches. Please correct length measurement.");
          return false;
        }
      }
    }
    return true;
  }

  // ── 6. Pricing, Layers, and UI Updates ──────────────────────────────────────
  const LAYER_INDICES = {
    body: 0, pocketSingle: 1, pocketFlap: 2, collarRegular: 3, collarButtonDown: 4, collarBand: 5,
    fullSleeveLeft: 6, fullSleeveRight: 7, halfSleeveLeft: 8, halfSleeveRight: 9,
    bottomCutTail: 10, bottomCutStraightSlits: 11, bottomCutStraight: 12,
    placketSkinny: 13, placketRegular: 14, placketConcealed: 15,
    backStitchBox: 16, backStitchSide: 17, backStitchDarts: 18,
  };

  const COLLAR_IMAGE_MAP = {
    "Classic Spread": LAYER_INDICES.collarRegular,
    "Button Down": LAYER_INDICES.collarButtonDown,
    "Mandarin (Bandh)": LAYER_INDICES.collarBand
  };
  const BOTTOM_CUT_IMAGE_MAP = {
    "Tail Cut": LAYER_INDICES.bottomCutTail,
    "Straight with Slits": LAYER_INDICES.bottomCutStraightSlits,
    "Straight Cut": LAYER_INDICES.bottomCutStraight,
  };
  const PLACKET_IMAGE_MAP = {
    "Skinny Placket": LAYER_INDICES.placketSkinny,
    "Classic Placket": LAYER_INDICES.placketRegular,
    "Hidden Placket": LAYER_INDICES.placketConcealed,
  };
  const BACK_STITCH_IMAGE_MAP = {
    "Box Pleats": LAYER_INDICES.backStitchBox,
    "Side Pleats": LAYER_INDICES.backStitchSide,
    "Plain Back": LAYER_INDICES.backStitchDarts,
  };
  const POCKET_IMAGE_MAP = {
    "No Pocket": null,
    "Left Chest": LAYER_INDICES.pocketSingle,
    "Pocket with Flap": LAYER_INDICES.pocketFlap,
  };
  const SLEEVE_IMAGE_MAP = {
    "Full Sleeve": [LAYER_INDICES.fullSleeveLeft, LAYER_INDICES.fullSleeveRight],
    "Short Sleeve": [LAYER_INDICES.halfSleeveLeft, LAYER_INDICES.halfSleeveRight],
  };

  function updateLivePreview() {
    const layers = document.querySelectorAll(".customizer-layer");
    if (!layers.length) return;
    
    layers.forEach(l => l.style.display = "none");
    
    const showLayer = (index, zIndex, top = "0px") => {
      const el = document.querySelector(`.layer-${index}`);
      if (el) {
        el.style.display = "block";
        el.style.zIndex = zIndex;
        el.style.top = top;
      }
    };

    try {
      showLayer(LAYER_INDICES.body, 1);
      const sleeves = SLEEVE_IMAGE_MAP[state.sleeve] || SLEEVE_IMAGE_MAP["Full Sleeve"];
      showLayer(sleeves[0], 2);
      showLayer(sleeves[1], 3);
      const bottomCut = BOTTOM_CUT_IMAGE_MAP[state.bottom] || LAYER_INDICES.bottomCutTail;
      showLayer(bottomCut, 4, "-1px");
      const collar = COLLAR_IMAGE_MAP[state.collar] || LAYER_INDICES.collarRegular;
      showLayer(collar, 5);
      const pocket = POCKET_IMAGE_MAP[state.pocket];
      if (pocket !== undefined && pocket !== null) showLayer(pocket, 6);
      const placket = PLACKET_IMAGE_MAP[state.placket] || LAYER_INDICES.placketSkinny;
      showLayer(placket, 8);
      if (state.activeStep === 8) {
        const backStitch = BACK_STITCH_IMAGE_MAP[state.back] || LAYER_INDICES.backStitchBox;
        showLayer(backStitch, 10);
      }
      
      // Render Dynamic Buttons Overlay
      const buttonsOverlay = document.getElementById('dynamic-buttons-overlay');
      if (buttonsOverlay) {
        buttonsOverlay.innerHTML = '';
        const btnCard = document.querySelector(`.customizer-option-card[data-key="buttons"][data-value="${state.buttons}"] img`);
        if (btnCard) {
          const btnSrc = btnCard.src;
          // When brand toggle is on, top button shows the red brand button (button3.png)
          const brandToggleEl = document.getElementById('brand-toggle-card');
          const brandBtnSrc = (state.brandShow && brandToggleEl?.dataset.brandBtnSrc)
            ? brandToggleEl.dataset.brandBtnSrc
            : null;

          const PLACKET_BUTTONS = [
            { top: "20%", left: "48.5%", size: "2.4%" },
            { top: "30%", left: "48.5%", size: "2.4%" },
            { top: "40%", left: "48.5%", size: "2.4%" },
            { top: "50%", left: "48.5%", size: "2.4%" },
            { top: "60%", left: "48.5%", size: "2.4%" },
            { top: "70%", left: "48.5%", size: "2.4%" },
            { top: "80%", left: "48.5%", size: "2.4%" }
          ];
          const COLLAR_BUTTONS = [
            { top: "18%", left: "43%", size: "2%" },
            { top: "18%", left: "56%", size: "2%" }
          ];

          if (state.placket !== "Hidden Placket") {
            PLACKET_BUTTONS.forEach((pos, index) => {
              const img = document.createElement('img');
              // Top button (index 0) = red brand button when toggle is on; rest follow selected style
              img.src = (index === 0 && brandBtnSrc) ? brandBtnSrc : btnSrc;
              img.style.position = 'absolute';
              img.style.top = pos.top;
              img.style.left = pos.left;
              img.style.width = pos.size;
              img.style.transform = 'translate(-50%, -50%)';
              img.style.zIndex = '9';
              img.style.objectFit = 'contain';
              buttonsOverlay.appendChild(img);
            });
          }

          if (state.collar === "Button Down") {
            COLLAR_BUTTONS.forEach(pos => {
              const img = document.createElement('img');
              img.src = btnSrc;
              img.style.position = 'absolute';
              img.style.top = pos.top;
              img.style.left = pos.left;
              img.style.width = pos.size;
              img.style.transform = 'translate(-50%, -50%)';
              img.style.zIndex = '9';
              img.style.objectFit = 'contain';
              buttonsOverlay.appendChild(img);
            });
          }
        }
      }
    } catch (e) {
      console.error("Live preview error:", e);
    }
  }

  function updateUI() {
    updateLivePreview();

    // Calculate total price (5% off material when brand button is included)
    const brandDiscount = state.brandButton === "Yes" ? 0.05 : 0;
    const discountedBase = basePrice * (1 - brandDiscount);
    const totalPrice = discountedBase + tailoringPrice;

    function formatRupees(amount) {
      var n = Number(amount);
      if (!isFinite(n)) n = 0;
      return `₹${n.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
    }

    const priceEl = document.getElementById("customizer-total-price") || totalPriceDisplay;
    if (priceEl) priceEl.textContent = formatRupees(totalPrice);

    const priceLabel = document.querySelector(".total-price-block .price-label");
    if (priceLabel) {
      let label = tailoringPrice > 0 ? "Total incl. tailoring" : "Total";
      if (brandDiscount > 0) label += " (5% off)";
      priceLabel.textContent = label;
    }

    // Update spec table (left panel) + confirm step spec table
    const brandLabel = state.brandButton === "Yes" ? "Yes (5% off)" : "No";
    const specMap = {
      "spec-for": state.for,
      "spec-size": state.size || "—",
      "spec-collar": state.collar,
      "spec-pocket": state.pocket,
      "spec-sleeve": state.sleeve,
      "spec-placket": state.placket,
      "spec-bottom": state.bottom,
      "spec-back": state.back,
      "spec-buttons": state.buttons,
      "spec-brand": state.brandButton,
      // Confirm step mirror
      "cspec-for": state.for,
      "cspec-size": state.size || "—",
      "cspec-collar": state.collar,
      "cspec-pocket": state.pocket,
      "cspec-sleeve": state.sleeve,
      "cspec-placket": state.placket,
      "cspec-bottom": state.bottom,
      "cspec-back": state.back,
      "cspec-buttons": state.buttons,
      "cspec-brand": brandLabel
    };
    Object.entries(specMap).forEach(([id, val]) => {
      const el = document.getElementById(id);
      if (el) el.textContent = val;
    });

    // Update Bottom Summary Text
    const summaryEl = document.getElementById("bottom-summary-text") || summaryTextDisplay;
    if (summaryEl) {
      const parts = [];
      if (state.for) parts.push(state.for);
      if (state.size && state.size !== "custom") parts.push(state.size);
      else if (state.size === "custom") parts.push("Custom Fit");
      if (state.collar) parts.push(state.collar);
      if (state.pocket && state.pocket !== "No Pocket") parts.push(state.pocket);
      if (state.sleeve) parts.push(state.sleeve);
      if (state.placket) parts.push(state.placket);
      if (state.bottom) parts.push(state.bottom);
      if (state.buttons) parts.push(state.buttons);

      summaryEl.textContent = parts.length ? parts.join(" · ") : "No selections yet";
    }

    // Next Button Validation
    let stepValid = true;
    if (state.activeStep === 2) {
      if (!state.size) stepValid = false;
      if (state.sizeMode === "custom") {
        const m = state.measurements;
        if (!m.neck || !m.chest || !m.waist || !m.shoulder || !m.sleeve || !m.length || parseFloat(m.length) > 37) {
          stepValid = false;
        }
      }
    }
    if (nextBtn) nextBtn.disabled = !stepValid;

    // Cart Button Validation
    if (state.activeStep === 10) {
      const isConfirmed = confirmCheckbox && confirmCheckbox.checked;
      const hasSize = !!state.size;
      if (buyMaterialBtn) buyMaterialBtn.disabled = !isConfirmed;
      // Only gate on checkbox; size check happens in click handler with visible feedback
      if (addTailoredBtn) addTailoredBtn.disabled = !isConfirmed;

      // Show inline size warning in the confirm step
      const sizeWarn = document.getElementById("confirm-size-warning");
      if (sizeWarn) sizeWarn.style.display = hasSize ? "none" : "block";
    }
  }

  // ── 7. Adding items to Shopify Cart via Ajax API ────────────────────────────
  function createLoadingOverlay() {
    const overlay = document.createElement("div");
    overlay.className = "customizer-loading-overlay";
    overlay.innerHTML = '<div class="spinner"></div>';
    document.body.appendChild(overlay);
    const style = document.createElement("style");
    style.innerHTML = `
      .customizer-loading-overlay { position: fixed; inset: 0; background: rgba(255,255,255,0.8); z-index: 9999; display: flex; align-items: center; justify-content: center; }
      .spinner { width: 40px; height: 40px; border: 4px solid #e5e7eb; border-top-color: #111827; border-radius: 50%; animation: spin 1s linear infinite; }
      @keyframes spin { 100% { transform: rotate(360deg); } }
    `;
    document.head.appendChild(style);
  }

  function removeLoadingOverlay() {
    const overlay = document.querySelector(".customizer-loading-overlay");
    if (overlay) overlay.remove();
  }

  if (buyMaterialBtn) {
    buyMaterialBtn.addEventListener("click", () => {
      if (!confirmCheckbox.checked) return;
      createLoadingOverlay();
      fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ items: [{ id: fabricVariantId, quantity: 1 }] })
      })
      .then(res => res.json())
      .then(() => window.location.href = "/cart")
      .catch(err => {
        console.error("Cart error:", err);
        alert("Failed to add material to cart.");
        removeLoadingOverlay();
      });
    });
  }

  if (addTailoredBtn) {
    addTailoredBtn.addEventListener("click", () => {
      if (!confirmCheckbox.checked) return;
      if (!state.size) {
        const sizeWarn = document.getElementById("confirm-size-warning");
        if (sizeWarn) {
          sizeWarn.style.display = "block";
          sizeWarn.scrollIntoView({ behavior: "smooth", block: "center" });
          sizeWarn.style.outline = "2px solid #F59E0B";
          setTimeout(() => { sizeWarn.style.outline = ""; }, 1200);
        }
        return;
      }
      if (state.sizeMode === "custom") {
        const m = state.measurements;
        if (!m.neck || !m.chest || !m.waist || !m.shoulder || !m.sleeve || !m.length) {
          state.activeStep = 2;
          goToStep(2);
          return;
        }
      }
      createLoadingOverlay();

      const properties = {
        "For": state.for,
        "Size": state.size === "custom" ? "Custom Sizing" : state.size,
        "Collar": state.collar,
        "Pocket": state.pocket,
        "Sleeve": state.sleeve,
        "Placket": state.placket,
        "Bottom Cut": state.bottom,
        "Back Stitch": state.back,
        "Buttons": state.buttons,
        "Brand Button": state.brandButton,
        "Tailoring Choice": "Tailored"
      };

      if (state.monogramText.trim() !== "") {
        properties["Monogram"] = `${state.monogramText.trim().toUpperCase()} (${state.monogramPosition}, ${state.monogramColor})`;
      }

      if (state.sizeMode === "custom") {
        properties["Measure Neck"] = `${state.measurements.neck}"`;
        properties["Measure Chest"] = `${state.measurements.chest}"`;
        properties["Measure Waist"] = `${state.measurements.waist}"`;
        properties["Measure Shoulder"] = `${state.measurements.shoulder}"`;
        properties["Measure Sleeve"] = `${state.measurements.sleeve}"`;
        properties["Measure Length"] = `${state.measurements.length}"`;
      }

      const itemsToAdd = [{ id: fabricVariantId, quantity: 1, properties: properties }];
      if (tailoringVariantId && tailoringVariantId !== "undefined" && tailoringVariantId !== "") {
        itemsToAdd.push({
          id: tailoringVariantId,
          quantity: 1,
          properties: { "For Fabric": productTitle }
        });
      }

      fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ items: itemsToAdd })
      })
      .then(res => res.json())
      .then(() => window.location.href = "/cart")
      .catch(err => {
        console.error("Cart error:", err);
        alert("Failed to add customized item to cart.");
        removeLoadingOverlay();
      });
    });
  }

  // ── 8. Modals & Save Design Logic (Local Storage) ───────────────────────────
  function openModal(modalEl) {
    modalEl.style.display = "flex";
  }
  function closeModal(modalEl) {
    modalEl.style.display = "none";
  }

  document.querySelectorAll(".close-modal, .cancel-btn, .modal-backdrop").forEach(btn => {
    btn.addEventListener("click", (e) => {
      const modal = e.target.closest(".customizer-modal") || document.querySelector(".customizer-modal[style*='flex']");
      if (modal && (e.target.classList.contains("modal-backdrop") || e.target.classList.contains("close-modal") || e.target.classList.contains("cancel-btn"))) {
        closeModal(modal);
      }
    });
  });

  if (saveDesignBtn && saveModal) {
    saveDesignBtn.addEventListener("click", () => {
      openModal(saveModal);
      if(saveNameInput) saveNameInput.focus();
    });
  }

  const saveConfirmBtn = document.querySelector(".save-btn");
  if (saveConfirmBtn && saveNameInput) {
    saveConfirmBtn.addEventListener("click", () => {
      const name = saveNameInput.value.trim();
      if (!name) return;
      
      const designs = JSON.parse(localStorage.getItem("tailor_saved_designs") || "[]");
      designs.push({
        id: Date.now().toString(),
        name: name,
        date: new Date().toLocaleDateString(),
        state: JSON.parse(JSON.stringify(state))
      });
      localStorage.setItem("tailor_saved_designs", JSON.stringify(designs));
      
      saveNameInput.value = "";
      closeModal(saveModal);
      alert(`Design "${name}" saved!`);
    });
  }

  if (myDesignsBtn && listModal) {
    myDesignsBtn.addEventListener("click", () => {
      const listContainer = document.getElementById("saved-designs-list");
      const designs = JSON.parse(localStorage.getItem("tailor_saved_designs") || "[]");
      
      if (designs.length === 0) {
        listContainer.innerHTML = `<p style="text-align:center; padding: 2rem 0; color: #6b7280; font-size: 0.875rem;">No saved designs yet.</p>`;
      } else {
        listContainer.innerHTML = designs.map(d => `
          <div class="saved-design-item">
            <div class="info">
              <h4>${d.name}</h4>
              <p>${d.date}</p>
            </div>
            <button class="apply-design-btn" data-id="${d.id}">Apply</button>
          </div>
        `).join("");
        
        document.querySelectorAll(".apply-design-btn").forEach(btn => {
          btn.addEventListener("click", (e) => {
            const id = e.target.dataset.id;
            const design = designs.find(x => x.id === id);
            if (design) {
              state = Object.assign(state, design.state);
              // Re-sync UI
              optionCards.forEach(c => {
                const k = c.dataset.key;
                if (state[k] === c.dataset.value) c.classList.add("selected");
                else c.classList.remove("selected");
              });
              if(state.monogramText && monogramTextInput) monogramTextInput.value = state.monogramText;
              if(state.monogramPosition && monogramPosSelect) monogramPosSelect.value = state.monogramPosition;
              populateStandardSizes();
              updateUI();
              closeModal(listModal);
              goToStep(1); // Reset to beginning
            }
          });
        });
      }
      openModal(listModal);
    });
  }

  // ── 9. Initial Setup ────────────────────────────────────────────────────────
  populateStandardSizes();
  goToStep(1);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initCustomizer);
} else {
  initCustomizer();
}
